import { DocumentSvg } from '@/screens/SberCredit/page/assets/DocumentSvg'
import { MessageSvg } from '@/screens/SberCredit/page/assets/MessageSvg'
import { ShoppingSvg } from '@/screens/SberCredit/page/assets/ShoppingSvg'
import { WalletSvg } from '@/screens/SberCredit/page/assets/WalletSvg'
import { FooterBannerProps } from '@/screens/SberCredit/page/ui/FooterBanner/FooterBanner'

export const stepListData = [
	{
		icon: WalletSvg,
		title: `Оформите заказ`,
		subtitle: `В способе оплаты укажите «Рассрочка от СберБанка»`
	},
	{
		icon: DocumentSvg,
		title: `Заполните заявку`,
		subtitle: `«Вы будете перенаправлены в СберБанк Онлайн, авторизуйтесь и заполните заявку`
	},
	{
		icon: MessageSvg,
		title: `Дождитесь одобрения`,
		subtitle: `Рассмотрение занимает не более 2 минут. Если рассрочка одобрена, заказ будет оплачен автоматически.`
	},
	{
		icon: ShoppingSvg,
		title: 'Получите товар',
		subtitle: 'Любым удобным для вас способом'
	}
]

export const footerBannerData: FooterBannerProps = {
	title: 'Что нужно для покупки?',
	list: [
		'Действующая дебетовая карта СберБанка',
		'СберБанк Онлайн с подключёнными СМС-уведомлениями',
		'Российская регистрация, гражданство',
		'Возраст от 18 до 70 лет'
	],
	image: {
		src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/sber/SberCard.png',
		height: 242,
		width: 326,
		style: { objectFit: 'contain' },
		alt: 'Изображение с картой Сбербанк'
	},
	buttonLabel: 'Узнать подробнее'
}

export const catData = [
	{
		code: 'apple_iphone',
		title: 'iPhone',
		imgSrc: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/home/categories/iphone.png',
		link: '/catalog/apple_iphone'
	},

	{
		code: 'apple_ipad',
		title: 'iPad',
		imgSrc: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/home/categories/ipad.png',
		link: '/catalog/apple_ipad'
	},
	{
		code: 'apple_mac',
		title: 'Mac',
		imgSrc: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/home/categories/imac.png',
		link: '/catalog/apple_mac'
	},
	{
		code: 'apple_watch',
		title: 'Watch',
		imgSrc:
			'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/home/categories/apple-watch.png',
		link: '/catalog/apple_watch'
	},
	{
		code: 'naushniki',
		title: 'AirPods',
		imgSrc: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/home/categories/airpods.png',
		link: '/catalog/naushniki/filter/airpods/'
	}
]
